var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerify1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.19,262.66c-10.69,39.89-36.08,84.39-76.25,100.69-60.69,24.64-63.33,75.71-175.67,81.76a226.91,226.91,0,0,1-49.07-2.47,187.94,187.94,0,0,1-23.47-5.39C78.82,417,39.14,362,30.47,301.33c-11.41-79.84,40.88-123.42,75.1-149.28S175.32,35.26,285.71,28.45A219.58,219.58,0,0,1,336.15,31c38,6.47,77.74,25,102.72,55.34q2.81,3.42,5.42,7C478.31,140.17,485.77,208.27,471.19,262.66Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.19,262.66c-10.69,39.89-36.08,84.39-76.25,100.69-60.69,24.64-63.33,75.71-175.67,81.76a226.91,226.91,0,0,1-49.07-2.47,187.94,187.94,0,0,1-23.47-5.39C78.82,417,39.14,362,30.47,301.33c-11.41-79.84,40.88-123.42,75.1-149.28S175.32,35.26,285.71,28.45A219.58,219.58,0,0,1,336.15,31c38,6.47,77.74,25,102.72,55.34q2.81,3.42,5.42,7C478.31,140.17,485.77,208.27,471.19,262.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.36,110.73v-5.67c0-11.18-7.44-15.14-15-15.14a14.63,14.63,0,0,0-14.88,15.14v5.67H56.32v31.38h34V110.73ZM74.32,128v5.69H71.1V128a4.29,4.29,0,1,1,3.22,0Zm9.33-17.24H63v-5.67A10.34,10.34,0,0,1,73.31,94.73c5.7,0,10.34,3.9,10.34,10.33Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.47,
    y: 51.63,
    width: 123.3,
    height: 26.95,
    rx: 13.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.11,63.85l2.81,3.1-1.35,1-2.1-3.69L121.4,68l-1.35-1,2.79-3.1L118.73,63l.5-1.62,3.87,1.7-.48-4.19h1.7l-.45,4.19,3.87-1.67.5,1.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.58,63.85l2.81,3.1L136,68l-2.09-3.69L131.87,68l-1.35-1,2.78-3.1L129.19,63l.51-1.62,3.87,1.7-.48-4.19h1.7l-.45,4.19,3.87-1.67.5,1.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145,63.85l2.81,3.1-1.35,1-2.09-3.69L142.34,68,141,67l2.78-3.1L139.66,63l.51-1.62,3.87,1.7-.48-4.19h1.7l-.45,4.19,3.87-1.67.5,1.62Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.51,63.85l2.81,3.1L157,68l-2.1-3.69L152.81,68l-1.35-1,2.78-3.1L150.13,63l.5-1.62,3.87,1.7L154,58.89h1.69l-.45,4.19,3.87-1.67.51,1.62Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166,63.85l2.81,3.1-1.35,1-2.1-3.69L163.28,68l-1.36-1,2.79-3.1L160.6,63l.5-1.62,3.87,1.7-.48-4.19h1.7l-.45,4.19,3.87-1.67.5,1.62Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.45,63.85l2.81,3.1-1.36,1-2.09-3.69L173.74,68l-1.35-1,2.78-3.1L171.06,63l.51-1.62,3.87,1.7L175,58.89h1.7l-.45,4.19,3.87-1.67.5,1.62Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.91,63.85l2.81,3.1-1.35,1-2.09-3.69L184.21,68l-1.35-1,2.78-3.1L181.53,63l.51-1.62,3.87,1.7-.48-4.19h1.7l-.45,4.19,3.87-1.67.5,1.62Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.38,63.85l2.81,3.1-1.35,1-2.1-3.69L194.68,68l-1.35-1,2.78-3.1L192,63l.5-1.62,3.87,1.7-.47-4.19h1.69l-.45,4.19L201,61.41l.51,1.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83.71,235.44A4.2,4.2,0,0,0,80.27,233H78v-2a12.32,12.32,0,0,0,2.67-7.77c0-5.1-3.07-9.24-6.86-9.24S67,218.13,67,223.23a12.48,12.48,0,0,0,2.47,7.55V233h-3a4.28,4.28,0,0,0-3.52,2.41l-4.11,6.92H87.71Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.43,
    cy: 230.18,
    r: 21.52,
    transform: "translate(-167.33 209.93) rotate(-67.5)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-67"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M234.33,323.75A121.58,121.58,0,0,1,317.87,98.39l-3.1,10.4,34.56-8.23-24.4-25.81-3,9.93a135.45,135.45,0,0,0-28.53-3c-74.91,0-135.86,60.94-135.86,135.85a136,136,0,0,0,73.58,120.72L222.55,324Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M343.56,91.24l10.67,11.29-13.1,3.12A121.6,121.6,0,0,1,258.22,333.9l4.22-7.65-35.51.69,18.35,30.41,5.92-10.72a135.32,135.32,0,0,0,42.23,6.73c74.91,0,135.86-60.94,135.86-135.86A136.08,136.08,0,0,0,343.56,91.24Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454,69.23l-22.9-4.37,0,.08c-1.14,2.31-3,3.59-4.73,3.26l-1-.19c-1.73-.32-3-2.21-3.2-4.78v-.08l-22.9-4.37a11.74,11.74,0,0,0-13.75,9.34L355.8,218.83a6.75,6.75,0,0,0,5.37,7.89l64.61,12.33a6.74,6.74,0,0,0,7.89-5.36L463.37,83A11.75,11.75,0,0,0,454,69.23Z",
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.73,86.34l.64-3.36A11.75,11.75,0,0,0,454,69.23l-22.9-4.37,0,.08c-1.14,2.31-3,3.59-4.73,3.26l-1-.19c-1.73-.32-3-2.21-3.2-4.78v-.08l-22.9-4.37a11.74,11.74,0,0,0-13.75,9.34l-.65,3.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.71,134.6,460.5,120l-1.32-.25L467.51,81a11.77,11.77,0,0,0-9.35-13.75l-62-11.84a11.76,11.76,0,0,0-13.75,9.35L351.85,219.85a11.74,11.74,0,0,0,9.34,13.75l62,11.84A11.76,11.76,0,0,0,437,236.1l17-89.28,1.32.26,1.65-8.65-1.32-.25.73-3.83Zm-22.79,92.56a11.77,11.77,0,0,1-13.76,9.34l-54.77-10.45a11.76,11.76,0,0,1-9.34-13.75L385.51,68.12a11.74,11.74,0,0,1,13.75-9.34l22.9,4.37v.08c.22,2.57,1.47,4.46,3.2,4.78l1,.19c1.72.33,3.59-1,4.73-3.26l0-.08L454,69.23A11.75,11.75,0,0,1,463.37,83Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.83,68.49l-58-11.07a12.46,12.46,0,0,0-14.57,9.9L353.62,217.83a12.45,12.45,0,0,0,9.9,14.57l58,11.06a12.45,12.45,0,0,0,14.57-9.9L465.73,83.05A12.45,12.45,0,0,0,455.83,68.49ZM434.92,227.16a11.77,11.77,0,0,1-13.76,9.34l-54.77-10.45a11.76,11.76,0,0,1-9.34-13.75L385.51,68.12a11.74,11.74,0,0,1,13.75-9.34l22.9,4.37v.08c.22,2.57,1.47,4.46,3.2,4.78l1,.19c1.72.33,3.59-1,4.73-3.26l0-.08L454,69.23A11.75,11.75,0,0,1,463.37,83Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.38,64.72a1.1,1.1,0,1,0-1.29.87A1.09,1.09,0,0,0,427.38,64.72Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.73,62.6c-.21,1.1-1.52,1.26-1.68,2.09v.06l1.19.23-.07.37L391.57,65l.06-.31c.22-1.17,1.5-1.17,1.69-2.19.07-.37,0-.6-.31-.65s-.47.13-.53.45l-.06.32-.38-.07,0-.3c.11-.55.43-.87,1-.77A.81.81,0,0,1,393.73,62.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.72,63v.09a.75.75,0,0,1-.59.66.74.74,0,0,1,.3.84l-.05.28c-.11.56-.44.87-1,.77s-.75-.52-.64-1.08l0-.25.38.07-.06.28c-.06.33,0,.55.33.6s.46-.11.53-.48l.06-.28c.06-.35,0-.55-.36-.62l-.22,0,.07-.36.24,0a.45.45,0,0,0,.53-.42l0-.17c.07-.37,0-.59-.32-.64s-.47.12-.53.45l0,.18-.38-.07,0-.17c.1-.55.43-.86,1-.76S395.83,62.42,395.72,63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.46,63.4l-.1.51-.39-.08.1-.5Zm-.38,2-.1.51-.39-.08.1-.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.22,63.89a.57.57,0,0,1,.59-.2c.47.09.61.47.51,1l-.13.71c-.11.56-.44.87-1,.76s-.74-.51-.64-1.07l.05-.25.38.08-.05.27c-.07.32,0,.55.32.6s.47-.11.53-.44l.13-.71c.07-.32,0-.55-.32-.6a.4.4,0,0,0-.49.31v.08l-.38-.07.48-2,1.44.27-.07.36-1.07-.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.57,63.9V64l-.38-.07,0-.09c.06-.33,0-.55-.34-.6s-.48.11-.55.5l-.16.81a.6.6,0,0,1,.67-.27c.46.09.61.46.51,1l-.11.55a.81.81,0,0,1-1,.76.82.82,0,0,1-.66-1.08l.36-1.85c.11-.58.44-.89,1-.78A.8.8,0,0,1,400.57,63.9ZM399.06,65l-.11.54c-.06.33,0,.55.33.61s.47-.11.54-.44l.1-.55c.06-.32,0-.55-.33-.6S399.12,64.69,399.06,65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.98,
    y: 71.51,
    width: 1.05,
    height: 2.61,
    transform: "translate(21.45 -81.12) rotate(10.81)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.4,
    y: 71.26,
    width: 1.05,
    height: 3.14,
    transform: "translate(21.46 -81.34) rotate(10.8)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.8,
    y: 71.15,
    width: 1.05,
    height: 3.51,
    transform: "translate(21.5 -81.61) rotate(10.8)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.24,
    y: 70.77,
    width: 1.05,
    height: 4.16,
    transform: "translate(21.52 -81.87) rotate(10.8)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.61,77.34l-6.16-1.17.71-3.77,6.17,1.18Zm-5.76-1.45,5.48,1,.59-3.09-5.48-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.63,
    y: 73.57,
    width: 3.31,
    height: 2.38,
    transform: "translate(22.05 -83.64) rotate(10.8)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.75,
    y: 75.04,
    width: 0.79,
    height: 0.9,
    transform: "matrix(0.98, 0.19, -0.19, 0.98, 22.24, -84.32)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.34,74.92a.24.24,0,0,1-.11-.06,1.84,1.84,0,0,0-2.11-.43.23.23,0,0,1-.32-.08.23.23,0,0,1,.08-.32,2.27,2.27,0,0,1,2.66.48.23.23,0,0,1,0,.33A.24.24,0,0,1,448.34,74.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,74.23a.22.22,0,0,1-.11,0,2.64,2.64,0,0,0-3-.61.23.23,0,1,1-.24-.4,3.12,3.12,0,0,1,3.59.66.23.23,0,0,1,0,.33A.22.22,0,0,1,449,74.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.55,73.42a.34.34,0,0,1-.12-.06,3.33,3.33,0,0,0-3.88-.76.24.24,0,0,1-.32-.09.23.23,0,0,1,.08-.32,3.85,3.85,0,0,1,4.43.82.23.23,0,0,1,0,.33A.22.22,0,0,1,449.55,73.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.57,75.17a.58.58,0,0,1-.68.47.59.59,0,1,1,.22-1.16A.58.58,0,0,1,447.57,75.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.04,
    y: 122.27,
    width: 65.92,
    height: 57.05,
    rx: 5.34,
    transform: "translate(35.53 -74.18) rotate(10.8)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.24,110.79l-.7-5.34.91.17.48,4.08,2-3.61.83.15L399.1,111l-.53,2.81-.87-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.76,108.21a1.84,1.84,0,1,1,3.59.69l-.77,4a1.84,1.84,0,1,1-3.59-.69Zm.08,4.26c-.14.72.09,1.19.71,1.31s1-.24,1.15-1l.79-4.14c.13-.71-.08-1.19-.71-1.31s-1,.25-1.15,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.23,113.31c-.13.71.06,1.18.7,1.31s1-.26,1.13-1l1.14-6,.82.16-1.14,5.94c-.23,1.19-.93,1.88-2.13,1.64s-1.6-1.12-1.37-2.31l1.13-5.94.86.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.63,108.32a1.58,1.58,0,0,1,1.4,2.13l-.12.64c-.17.86-.57,1.34-1.28,1.42a1.5,1.5,0,0,1,.67,1.82l-.23,1.22a2,2,0,0,0,0,1l-.88-.16a2.09,2.09,0,0,1,0-1l.23-1.23c.17-.89-.19-1.25-.92-1.39l-.61-.11-.64,3.34-.88-.16,1.5-7.84ZM411.7,112c.69.13,1.15,0,1.31-.87l.14-.75c.14-.7,0-1.12-.7-1.25l-.85-.16-.55,2.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.12,111.72l-.13.7-.83-.16.14-.75c.14-.7-.06-1.18-.7-1.3s-1,.25-1.13,1l-.79,4.14c-.14.71.07,1.19.7,1.31s1-.25,1.13-1l.2-1,.83.15-.19,1c-.23,1.18-.93,1.86-2.14,1.63s-1.61-1.12-1.38-2.31l.77-4c.22-1.18.93-1.86,2.13-1.63A1.73,1.73,0,0,1,420.12,111.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.85,111.85a1.84,1.84,0,1,1,3.6.69l-.78,4a1.83,1.83,0,1,1-3.59-.68Zm.08,4.27c-.13.71.09,1.18.72,1.3s1-.23,1.14-1l.79-4.14c.14-.71-.07-1.19-.71-1.31s-1,.25-1.15,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.47,111.16a1.7,1.7,0,0,1,1.41,2.28l-.75,4c-.23,1.19-.93,1.83-2.15,1.59l-1.84-.35,1.5-7.83Zm-1.35,7c.63.12,1-.22,1.14-.94l.77-4c.13-.72-.09-1.17-.73-1.29l-.94-.18L425.17,118Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.2,115.66l-.15.78-1.92-.37-.53,2.79,2.35.45-.15.79-3.22-.61,1.49-7.84,3.23.62-.16.79-2.35-.45-.51,2.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.22,142.53a2.42,2.42,0,0,1,2.43-.8c1.9.36,2.48,1.92,2.07,4l-.55,2.89c-.43,2.26-1.79,3.53-4.05,3.1s-3-2.11-2.6-4.37l.19-1,1.54.29-.21,1.1c-.25,1.33.14,2.24,1.32,2.46s1.89-.47,2.14-1.8l.55-2.87c.26-1.33-.14-2.24-1.32-2.46a1.61,1.61,0,0,0-2,1.26l-.07.34-1.54-.29,2-8.14,5.83,1.11-.28,1.48-4.35-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.84,142.57l0,.28-1.54-.3.07-.38c.26-1.33-.14-2.21-1.35-2.44s-2,.46-2.25,2l-.63,3.32a2.41,2.41,0,0,1,2.69-1.13c1.9.36,2.48,1.89,2.07,4l-.42,2.24c-.43,2.26-1.84,3.52-4.09,3.09s-3.12-2.13-2.69-4.39l1.44-7.54c.44-2.34,1.78-3.6,4.12-3.15S406.27,140.31,405.84,142.57Zm-6.14,4.57-.42,2.21c-.26,1.33.14,2.24,1.34,2.47s1.91-.47,2.16-1.8l.42-2.22c.26-1.33-.16-2.24-1.34-2.46S400,145.81,399.7,147.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.06,144.14l-.05.28-1.55-.3.08-.38c.25-1.33-.15-2.21-1.35-2.44s-1.95.46-2.25,2l-.64,3.31a2.43,2.43,0,0,1,2.69-1.12c1.9.36,2.49,1.89,2.08,4l-.43,2.23c-.43,2.26-1.83,3.53-4.09,3.1s-3.12-2.13-2.69-4.39L407.3,143c.45-2.34,1.78-3.6,4.13-3.15S414.49,141.88,414.06,144.14Zm-6.15,4.56-.42,2.22c-.25,1.33.14,2.24,1.35,2.47s1.9-.47,2.16-1.8l.42-2.22c.25-1.33-.16-2.24-1.35-2.47S408.17,147.37,407.91,148.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.27,145.73l-1.44,7.54c-.45,2.34-1.78,3.62-4.15,3.17s-3.06-2.1-2.63-4.35l.06-.28,1.54.29-.08.39c-.25,1.33.17,2.22,1.35,2.44s2-.45,2.27-2l.63-3.31a2.4,2.4,0,0,1-2.68,1.1c-1.9-.36-2.49-1.87-2.08-4l.43-2.26c.43-2.26,1.81-3.51,4.09-3.08S422.7,143.47,422.27,145.73Zm-5.14-1.07-.42,2.22c-.25,1.33.16,2.24,1.35,2.47s1.9-.47,2.15-1.8l.43-2.22c.26-1.35-.14-2.24-1.35-2.47S417.39,143.31,417.13,144.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.64,147.26l-.09.47c-.28,1.5-1,2.49-2.27,2.72,1.14.71,1.38,2,1.1,3.44l-.21,1.1c-.44,2.28-1.89,3.47-4.19,3s-3.22-2.08-2.78-4.36l.21-1.1c.28-1.5,1-2.53,2.31-2.8-1.12-.69-1.42-1.86-1.13-3.36l.08-.47c.44-2.28,1.9-3.42,4.19-3S431.08,145,430.64,147.26Zm-5.35-1-.13.71c-.28,1.44.3,2.21,1.46,2.43s2-.28,2.25-1.72L429,147c.29-1.52-.27-2.35-1.44-2.57S425.58,144.76,425.29,146.29Zm-1.22,6.39-.24,1.25c-.29,1.52.25,2.37,1.43,2.59s2-.36,2.29-1.88l.24-1.25c.27-1.43-.23-2.25-1.45-2.48S424.35,151.25,424.07,152.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.37,
    y1: 186.51,
    x2: 428.43,
    y2: 196.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.47,
    y1: 196.47,
    x2: 426.52,
    y2: 206.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 460.16,
    y1: 148.98,
    x2: 472.51,
    y2: 147.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.26,
    y1: 163.23,
    x2: 464.91,
    y2: 165.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 454.46,
    y1: 175.58,
    x2: 466.81,
    y2: 184.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.77,172.7a2.42,2.42,0,0,0,2.42-2.42v-20a2.42,2.42,0,0,0-2.42-2.42h-.1v-7.82A9.65,9.65,0,0,0,332,130.4H121a9.65,9.65,0,0,0-9.65,9.65V285.82a9.65,9.65,0,0,0,9.65,9.64H332a9.65,9.65,0,0,0,9.65-9.64v-52.3h.1a2.42,2.42,0,0,0,2.42-2.42v-20a2.42,2.42,0,0,0-2.42-2.42h-.1v-2.53h.1a2.42,2.42,0,0,0,2.42-2.42v-20a2.42,2.42,0,0,0-2.42-2.42h-.1V172.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.98,
    y: 136.83,
    width: 213.09,
    height: 152.2,
    style: {
      fill: "#7E57C2",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.29,
    y: 156.4,
    width: 119.17,
    height: 95.71,
    style: {
      fill: "#e3e3e3",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.13,225.59v.6h-1.46v2.13h1.79v.6H210v-6h2.46v.6h-1.79v2.05Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.67,228.92h-.6v-6h.84l1.39,4.32v-4.32h.59v6h-.69l-1.53-4.84Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.44,228.92v-5.38h-1.11v-.6h2.87v.6h-1.1v5.38Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,225.59v.6h-1.46v2.13h1.79v.6h-2.46v-6h2.46v.6h-1.79v2.05Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.06,222.94c.94,0,1.34.47,1.34,1.36v.49c0,.66-.23,1.07-.75,1.23.55.17.76.61.76,1.25v.93a1.39,1.39,0,0,0,.12.72h-.68a1.5,1.5,0,0,1-.11-.72v-.94c0-.68-.32-.89-.87-.89h-.47v2.55h-.67v-6Zm-.17,2.82c.53,0,.85-.17.85-.82v-.58c0-.53-.2-.82-.69-.82h-.65v2.22Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.07,224.38v.54h-.64v-.57c0-.54-.21-.87-.7-.87s-.7.33-.7.87v3.16c0,.54.22.87.7.87s.7-.33.7-.87v-.78h.64v.75c0,.9-.43,1.5-1.36,1.5s-1.34-.6-1.34-1.5v-3.1c0-.91.43-1.5,1.34-1.5S230.07,223.47,230.07,224.38Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.62,224.38c0-.91.45-1.5,1.37-1.5a1.31,1.31,0,0,1,1.38,1.5v3.1A1.32,1.32,0,0,1,232,229c-.92,0-1.37-.6-1.37-1.5Zm.66,3.13c0,.55.23.87.71.87s.71-.32.71-.87v-3.16c0-.54-.22-.87-.71-.87s-.71.33-.71.87Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.4,222.94c.93,0,1.36.56,1.36,1.48v3c0,.92-.43,1.48-1.36,1.48H234v-6Zm0,5.38c.48,0,.71-.3.71-.85v-3.08c0-.55-.23-.85-.72-.85h-.71v4.78Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.51,225.59v.6h-1.46v2.13h1.8v.6h-2.47v-6h2.47v.6h-1.8v2.05Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.49,
    y: 188.01,
    width: 100.56,
    height: 11.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.49,
    y: 206.01,
    width: 100.56,
    height: 11.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.49,
    y: 231.61,
    width: 9.49,
    height: 11.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.4,
    y: 231.61,
    width: 9.49,
    height: 11.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.32,
    y: 231.61,
    width: 9.49,
    height: 11.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.67,
    y: 231.61,
    width: 9.06,
    height: 11.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.57,
    y: 231.61,
    width: 9.84,
    height: 11.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.67,169.39v-2.18a6.42,6.42,0,0,0-12.83,0v2.18h-.12v12.06h13.07V169.39Zm-6,6.63v2.18H224.4V176a1.65,1.65,0,1,1,1.24,0Zm3.59-6.63h-7.95v-2.18a4,4,0,0,1,7.95,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2,195.07c0,.54.21.86.7.86s.69-.32.69-.86v-4.58h.63V195c0,.91-.42,1.52-1.35,1.52s-1.33-.61-1.33-1.52v-4.54h.66Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.47,191.93v.16h-.64v-.2c0-.53-.2-.85-.68-.85s-.68.32-.68.85c0,1.34,2,1.47,2,3.15,0,.91-.44,1.5-1.36,1.5s-1.34-.59-1.34-1.5v-.34h.63v.38c0,.53.22.85.7.85s.7-.32.7-.85c0-1.34-2-1.47-2-3.15,0-.93.42-1.5,1.32-1.5S216.47,191,216.47,191.93Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.19,193.14v.6h-1.47v2.13h1.8v.61h-2.46v-6h2.46v.61h-1.8v2Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.47,190.49c.94,0,1.33.48,1.33,1.37v.49c0,.66-.23,1.07-.74,1.23.55.16.75.61.75,1.25v.93a1.54,1.54,0,0,0,.12.72h-.67a1.52,1.52,0,0,1-.12-.73v-.94c0-.68-.31-.89-.87-.89h-.47v2.56h-.67v-6Zm-.17,2.82c.53,0,.84-.17.84-.82v-.57c0-.54-.19-.82-.69-.82h-.65v2.21Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.42,196.48h-.6v-6h.85l1.38,4.33v-4.33h.59v6H227l-1.53-4.84Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,195.27l-.23,1.21h-.62l1.15-6h1l1.14,6h-.66l-.24-1.21Zm.09-.57h1.33l-.67-3.46Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.14,196.47h-.64l-1-4.76v4.77h-.58v-6h.93l1,4.78.95-4.78h.93v6h-.63v-4.82Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.53,193.14v.6h-1.46v2.13h1.8v.61h-2.46v-6h2.46v.61h-1.8v2Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.11,211.12l.91,1-.44.32-.67-1.19-.67,1.19-.43-.32.89-1-1.32-.28.16-.52,1.25.55-.15-1.35h.54l-.14,1.35,1.25-.54.16.52Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.49,211.12l.91,1-.44.32-.67-1.19-.67,1.19-.44-.32.9-1-1.32-.28.16-.52,1.25.55-.16-1.35h.55l-.15,1.35,1.25-.54.17.52Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.87,211.12l.91,1-.44.32-.68-1.19-.66,1.19-.44-.32.9-1-1.33-.28.17-.52,1.24.55-.15-1.35h.55l-.15,1.35,1.25-.54.16.52Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.25,211.12l.9,1-.43.32-.68-1.19-.67,1.19-.43-.32.9-1-1.33-.28.16-.52,1.25.55-.15-1.35h.54l-.14,1.35,1.25-.54.16.52Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,211.12l.91,1-.44.32-.67-1.19-.67,1.19-.43-.32.89-1-1.32-.28.16-.52,1.25.55-.16-1.35h.55l-.14,1.35,1.25-.54.16.52Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,211.12l.91,1-.44.32-.67-1.19-.67,1.19-.44-.32.9-1-1.33-.28.17-.52,1.25.55-.16-1.35h.55l-.15,1.35,1.25-.54.17.52Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.38,211.12l.91,1-.44.32-.68-1.19-.66,1.19-.44-.32.9-1-1.33-.28.16-.52,1.25.55-.15-1.35h.55l-.15,1.35,1.25-.54.16.52Z",
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.76,211.12l.9,1-.43.32-.68-1.19-.67,1.19-.43-.32.9-1-1.33-.28.16-.52,1.25.55-.15-1.35h.54l-.14,1.35,1.25-.54.16.52Z",
    style: {
      fill: "#b2b2b2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mug--inject-67"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.96,
    cy: 423.6,
    rx: 63.97,
    ry: 60.11,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.61,
    cy: 420.47,
    rx: 63.97,
    ry: 60.11,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.61,
    cy: 420.47,
    rx: 55.21,
    ry: 51.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.91,385.54c-22.16,0-40.13,22.57-40.13,50.42,0,18,7.49,33.72,18.74,42.65,1.86.16,3.74.25,5.64.25,23.3,0,43.61-11.92,54.46-29.62A62.62,62.62,0,0,0,291,436C291,408.11,273.07,385.54,250.91,385.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.12,
    y: 413.22,
    width: 26.13,
    height: 6.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.83,
    cy: 416.01,
    rx: 39.86,
    ry: 37.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.83,
    cy: 416.01,
    rx: 33.27,
    ry: 31.27,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.89,387.33a12.54,12.54,0,0,0-.74-1.52c-3.4-5.91-3-13.42-.43-20.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.42,399.76s1.78-6.76-.53-12.43",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.29,385.81c-3.39-5.91-3-13.42-.42-20.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.56,399.76s2.12-8.05-1.27-13.95",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.86,386.6c-.13-.27-.27-.53-.42-.79-3.39-5.91-3-13.42-.43-20.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.71,399.76s1.94-7.35-.85-13.16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--right-hand--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.14,360.24s-1,.06-2.91.26c-1.76-6-7.06-23.74-10.54-32.91-4.22-11.14-10-26.89-13.82-33.42s-3.46-10.37-10.76-16.51-13.83-3.46-13.83-3.46-1.15-4.61-8.45-6.91-17.28,2.3-17.28,2.3-1.54-2.69-8.84-1.92a12.71,12.71,0,0,0-10,7.3s-15-30-20.74-32.27-11.53,3.46-9.22,8.84,19.59,35.34,21.89,42.25,7.3,18.44,7.3,18.44-16.52-11.91-21.51-13.06-12.29-1.92-16.52,2.69,5.76,5.76,13.83,13.06,21.13,24.19,27.27,34.95,19.21,12.68,25,18.82c4.05,4.33,9.82,10.36,12.88,13.56a33.58,33.58,0,0,0-2.89,3.34l12.67,31.11s2.69-4.22,13.45-12.67,44.17-18.82,44.17-18.82Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.51,376.4s-9.22-9.6-15-15.74-18.82-8.07-25-18.83-19.21-27.65-27.27-34.95-18.05-8.45-13.83-13.06S260,290,265,291.13s21.51,13.06,21.51,13.06-5-11.52-7.3-18.43S259.6,248.88,257.3,243.5s3.45-11.14,9.21-8.83,20.75,32.26,20.75,32.26a12.66,12.66,0,0,1,10-7.29c7.3-.77,8.84,1.92,8.84,1.92s10-4.61,17.28-2.31,8.45,6.92,8.45,6.92,6.53-2.69,13.83,3.45,6.91,10,10.75,16.52,9.61,22.28,13.83,33.42,11.14,34.95,11.14,34.95L331.81,381.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 287.26,
    y1: 266.93,
    x2: 300.7,
    y2: 286.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.08,
    y1: 261.56,
    x2: 318.37,
    y2: 280.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.81,
    y1: 266.17,
    x2: 340.26,
    y2: 281.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.41,
    y1: 321.37,
    x2: 294.17,
    y2: 326.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.49,
    y1: 304.19,
    x2: 291.19,
    y2: 317.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308,
    y1: 291.52,
    x2: 311.07,
    y2: 295.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.21,
    y1: 287.29,
    x2: 325.67,
    y2: 291.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 341.03,
    y1: 284.99,
    x2: 343.33,
    y2: 292.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.51,377.56s8.84-12.29,26.89-18.44a133,133,0,0,1,32.27-6.91l11.14,25S361.39,387.54,350.63,396s-13.44,12.68-13.44,12.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.86,460.52s-14.6-36.49-18.44-44.17,2.31-11.52,2.31-11.52,8.83-11.91,31.88-21.13,25-9.6,30.72-3.07,43.56,80,43.56,80",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--left-hand--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.08,422.13a41.72,41.72,0,0,1,17.66-17.54c12.43-6.34,20.51-9.07,32.41-20.81s31.51-22.22,39.59-23.66,10.77-4.93,7.29-8.89-13-4.19-21.45-1.33-16.29,6.36-16.29,6.36c4.29-8.44,7.14-18.61,11.36-27.08,3-6,7.91-15.94,10.83-22,1.9-3.95,7.56-10.53,5-14.85s-8.59-1.45-11.66,2.67c-4.88,6.56-28.75,42.55-28.75,42.55l13.61-28.8c6.89-14.59,10.17-21.55,9.2-19.48,2-4.26,5.92-10,3.53-14.87a7.05,7.05,0,0,0-12.33-.74c-3.32,5.4-28.69,53.41-28.69,53.41s15.88-41.2,17.91-45.94c2.48-5.78,1-10.83-2.64-10.8-5.32,0-7.83,5.93-9.91,9.93l1.16-1.69c-5,6.63-8.31,15.33-12.47,22.52Q133.19,313.71,125.4,326c1-8.49,4.43-16.45,8.65-23.82,2.55-4.44,13.16-15.35,11.34-20.71-1.56-4.62-13.19,4.06-20,13.53-3.68,5.16-13.35,19.24-16,29.14s-21.28,43.63-26.25,53-10.94,26-10.94,26Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.27,413.07s-9.58-11.72-28-16.74a133.36,133.36,0,0,0-32.63-4.91L59.08,417s34,8.3,45.25,16.07,14.2,11.82,14.2,11.82Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.82,417.69a41.74,41.74,0,0,1,17.65-17.53c12.43-6.35,20.52-9.08,32.41-20.81s31.51-22.22,39.6-23.67,10.77-4.92,7.28-8.89-13-4.18-21.45-1.32S173,351.82,173,351.82c4.29-8.44,7.14-18.6,11.36-27.08,3-6,7.92-15.93,10.83-22,1.9-3.95,7.56-10.53,5-14.84s-8.58-1.46-11.65,2.67c-4.88,6.56-28.75,42.54-28.75,42.54q6.79-14.4,13.6-28.79c6.89-14.59,10.18-21.55,9.2-19.49,2-4.25,5.93-9.95,3.54-14.86a7.06,7.06,0,0,0-12.34-.75c-3.32,5.41-28.69,53.42-28.69,53.42s15.88-41.21,17.91-45.94c2.48-5.79,1-10.83-2.64-10.8-5.32,0-7.83,5.92-9.91,9.93l1.16-1.69c-5,6.62-8.31,15.33-12.47,22.52q-7.28,12.6-15.08,24.9c1-8.49,4.43-16.44,8.65-23.81,2.55-4.44,13.16-15.35,11.35-20.72-1.56-4.61-13.2,4.06-20,13.54-3.69,5.16-13.35,19.23-16,29.14s-21.28,43.62-26.25,53-10.94,26-10.94,26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.16,
    y1: 322.65,
    x2: 140.57,
    y2: 331.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.85,
    y1: 333.12,
    x2: 156.27,
    y2: 337.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.02,
    y1: 351.82,
    x2: 168.42,
    y2: 358.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.24,
    y1: 347.42,
    x2: 148.87,
    y2: 351.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.78,
    y1: 340.15,
    x2: 137.8,
    y2: 344,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.92,
    y1: 332.12,
    x2: 121.85,
    y2: 338.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,408.64s-9.58-11.72-28-16.74A133.42,133.42,0,0,0,67.4,387l-9.58,25.6s34,8.29,45.25,16.06,14.2,11.83,14.2,11.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.76,464s2.39-8,5.75-15.91-3-11.36-3-11.36-9.56-11.34-33.13-19.12-25.51-8.05-30.86-1.18S29,464.62,29,464.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify1);
export default __webpack_public_path__ + "static/media/Verify1.b13dc5032ffe1da2a2b50753c091b76f.svg";
export { ForwardRef as ReactComponent };